import _ from 'lodash'

export const __ = _

export default {
  install: (app) => {
    app.config.globalProperties.$__ = __
  }
}
